<template>
  <v-container class="add_item-container">
    <v-col class="add_item-wrapper">
      <v-row justify="center">
        <v-col cols="10" xs="10" sm="8" md="8" lg="8" class="vertical-no-padding-col">
          <TitleLabel :title="title" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="11" xs="11" sm="6" md="4" lg="4" class="vertical-no-padding-col">
          <NormalTextField label="ここに入力してください" :form-data.sync="ecoItem" :form-show="formShow" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="11" xs="11" sm="6" md="4" lg="4" class="vertical-no-padding-col">
          <NormalButton button-title="送信する" :form-show="formShow" @clickAction="addItem" />
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import TitleLabel from '../Atoms/TitleLabel'
import NormalTextField from '../Atoms/NormalTextField'
import NormalButton from '../Atoms/NormalButton'

export default {
  name: "AddItem",
  data: () => ({
    accessToken:"",
    title: "追加したいエコを記入しよう！",
    formShow:true,
    ecoItem: ""
  }),
  created() {
    this.fetchInitialData()
  },
  methods: {
    // API通信を行うのに必要な情報を取得する
    fetchInitialData() {
      const user_info = this.$store.getters["user/getUserInfo"];
      this.accessToken = user_info.accessToken;
    },
    addItem() {
      const header = {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
      const data = {
        eco_content: this.ecoItem
      }
      return new Promise((resolve, reject) => {
        this.axios
          .post("/api/add_eco_items", data, header)
          .then(response => {
            console.log("エコ項目追加依頼のresponse", response)
            this.$router.push('addItemResult')
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  components:{
    TitleLabel,
    NormalTextField,
    NormalButton
  }
};
</script>

<style scoped>
.add_item-container {
  height: 60%;
}
.add_item-wrapper {
  padding: 20% 0 20% 0;
}
@media screen and (max-width: 350px) {
}
@media screen and (min-width: 351px) and (max-width: 768px) {
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
@media screen and (min-width: 1024px) {
}
</style>
